import React from "react";
import { Container,Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ErrorBanner.css";
const ErrorBanner = () => {
  return (
    <div>
      <div className="error-wrapper d-flex align-items-center justify-content-center">
        <Container>
          <div className="row align-items-center">
            <div className="col-12 col-md-5">
              <div className="error-text">
                <h1>404</h1>
                <h3>We sincerly apologize</h3>
                <span>oops, sorry...</span>
                <p>
                  The page you are looking for is unavailable in this site.Please check the correct route from the navigation bar and try again.If you can't then back to home throught the home button bellow.
                </p>
                <Link to="/"><Button variant="light border rounded-0">Back to Home</Button></Link>
              </div>
            </div>
            <div className="col-12 col-md-7">
              <div className="error-img">
                <img
                  src={require("../../../images/error/error.jpg")}
                  className="h-100 w-100"
                  alt=""
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ErrorBanner;
